const yup = require("yup");

// Schema for createcollegerules
const selectStudentRule = yup.object({
  student: yup.string().min(2, "Minimum of 2 characters expected").required("Department is required"),
});

module.exports = {
  selectStudentRule,
};
